import React from 'react'
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';


export default function Company() {

  return (
    

<ul>
<li><Link to='/who-we-are'>Who We Are</Link></li>
{/* <li><Link to='/what-we-do'>What We Do</Link></li>
<li><Link to='/our-values'>Our Values</Link></li> */}
<li><HashLink to='/who-we-are#vision-mission'>Vision & Mission</HashLink></li>
</ul>

  )
}



